module.exports = __webpack_public_path__ + "img/p2-10.7dd6427b.png";